import React from 'react';
import { Link, NavLink } from 'react-router-dom';

import useAuth from '../auth/useAuth';
import { useUnits } from '../units/UnitContext';
import './Navbar.css';

const Navbar = () => {
  const { user, loading } = useAuth();
  const { unitSystem, setUnitSystem } = useUnits();

  return (
    <header className="globalNavbar">
      <nav className="mainNavbar" aria-label="Primary navigation">
        <div className="leftSection">
          <Link to="/">
            <img src="/favicon/android-chrome-512x512.png" alt="Home" className="homeIcon" />
          </Link>
        </div>
        <div className="mainMenuNavbar">
          <NavLink to="/materials">Materials</NavLink>
          <NavLink to="/tolerances">Tolerances</NavLink>
          <NavLink to="/threads">Threads</NavLink>
        </div>
        <div className="unitSwitch" role="group" aria-label="Display units">
          {['metric', 'inch'].map(system => <button key={system} type="button" aria-label={`Use ${system === 'metric' ? 'millimetres' : 'inches'}`} aria-pressed={unitSystem === system} className={unitSystem === system ? 'active' : ''} onClick={() => setUnitSystem(system)}>{system === 'metric' ? 'mm' : 'in'}</button>)}
        </div>
        <div className={user ? 'loginSection loginSectionLoggedIn' : 'loginSection'}>
          {loading ? (
            <span className="authLoading">Loading...</span>
          ) : user ? (
            <>
              <span className="login-indicator loggedIn"></span>
              <span className="authEmail" title={user.email}>
                {user.email}
              </span>
              <Link className="profileLink" to="/profile">Profile</Link>
            </>
          ) : (
            <>
              <span className="login-indicator"></span>
              <Link to="/login">Sign in</Link>
            </>
          )}
        </div>
      </nav>
    </header>
  );
};

export default Navbar;
